import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  const heroStyle = {
    backgroundImage: "url('/images/hero.png')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };

  return (
    <section className="hero-wrapper" style={heroStyle}>
      <div className="hero-container">
        <div className="hero-overlay">
          <div className="hero-content">
            <h4 className="hero-tagline">Events Designed With Style & Precision</h4>
            <h1 className="hero-title">Creative Event Management In Dubai</h1>
            <Link to="/contact" className="hero-cta">Contact Us</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;